
import worker from "../setupWorker";
import axiosClient from "./axiosClient";

export const getHeader = function (token) {
  if (!token && localStorage) {
    token = localStorage["access_token"];
  }

  return {
    "content-type": "application/json",
    Authorization: token,
  };
};
const refreshToken = async function () {
  try {


  } catch (e) {
    throw e;
  }
};
const ApiHelper = {
  post: async function (url, data, cfg) {
    let config = { headers: getHeader() };
    if (cfg) {
      config = { ...config, ...cfg };
    }
    await refreshToken();
    let result = {};
    try {
      result = await axiosClient.post(url, data, config);
      if (result.data.errorCode == 501 || result.data.errorCode == 401) {
        localStorage['access_token'] = ""
        console.log("Require Login")
        window.location = "/";
      }
      return result;
    } catch (e) {
      if (e.code == 'ERR_NETWORK') {
        worker.postMessage({ type: 'showsnackbar', data: 'Lỗi kết nối mạng, liên hệ admin' })
      }
      else if (e.response.status && e.response.status == 401) {
        localStorage['access_token'] = ""
        console.log("Require Login")
        window.location = "/";
      } else {
        throw e;
      }
    }
  },
  get: async (url, cfg, token) => {
    try {
      url = url.replace("+", "%2B");
      await refreshToken();
      let result
      let header = getHeader()
      if (token)
        header = getHeader(token)
      if (cfg == undefined)
        result = await axiosClient.get(url, { headers: header });
      else
        result = await axiosClient.get(url, { headers: header, ...cfg });
      if (result.data.errorCode == 501 || result.data.errorCode == 401) {
        localStorage['access_token'] = ""
        console.log("Require Login")
        window.location = "/";
      }
      return result;
    } catch (e) {
      if (e.response.status === 401 || e.response.status == 500) {

      } else {
        throw e;
      }
    }
  },
  delete: async (url) => {
    try {
      await refreshToken();
      return await axiosClient.delete(url, { headers: getHeader() });
    } catch (e) {
      if (e.response.status === 401 || e.response.status == 500) {
        window.location = "/";
      } else {
        throw e;
      }
    }
  },
};
export default ApiHelper;
